/* eslint-disable @typescript-eslint/no-misused-promises */

import React from 'react';
import {
  FieldValues, FormProvider, UseFormReturn,
} from 'react-hook-form';
import { InputField } from '../../../Forms/Fields';
import { RepresentativeSchema } from '../schemas';

interface FormProps<T extends FieldValues>
  extends Omit<React.ComponentPropsWithRef<'form'>, 'onSubmit'> {
  children?: React.ReactNode;
  form: UseFormReturn<T>;
  onSubmit: (data: T) => void | Promise<void | T>;
}

export function RepresentativeForm({
  form, onSubmit, children,
}: FormProps<Pick<RepresentativeSchema, 'representative_email'>>) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="modal-form">

        <InputField<Pick<RepresentativeSchema, 'representative_email'>>
          id="representative_email"
          path="representative_email"
          label="Email"
          placeholder="Email del representante"
        />
        {children}
      </form>
    </FormProvider>
  );
}
